import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import { MESSAGE_FIELDS } from '#/graphql/fragments/message-fields';
import type {
  ToggleMessageReactionMutation,
  ToggleMessageReactionMutationVariables,
} from '#/graphql/generated';

export const TOGGLE_MESSAGE_REACTION: TypedDocumentNode<
  ToggleMessageReactionMutation,
  ToggleMessageReactionMutationVariables
> = gql`
  ${MESSAGE_FIELDS}
  mutation ToggleMessageReaction($input: ToggleMessageReactionInput!) {
    toggleMessageReaction(input: $input) {
      ...MessageFields
    }
  }
`;
